import React from 'react';
import './ServicePages.css';

const MsFabricPage = ({ onContactClick }) => {
  const features = [
    { icon: "🏗️", title: "Lakehouse Architecture", desc: "Design and implement unified data lakehouses that combine the best of data lakes and warehouses." },
    { icon: "📊", title: "Power BI Integration", desc: "Build stunning, real-time dashboards and reports directly connected to your Fabric workspace." },
    { icon: "🔄", title: "Data Pipeline Design", desc: "Create automated ETL/ELT pipelines that transform and move data reliably across your organization." },
    { icon: "🤖", title: "Fabric AI Features", desc: "Leverage built-in Copilot and AI capabilities within Fabric for smart data exploration and insights." },
    { icon: "🔐", title: "Governance & Security", desc: "Implement robust data governance, lineage tracking, and role-based access controls." },
    { icon: "☁️", title: "Migration Services", desc: "Seamlessly migrate from legacy data platforms to Microsoft Fabric with zero data loss." }
  ];

  return (
    <div className="service-page theme-fabric">
      <section className="svc-hero">
        <div className="svc-hero-content">
          <h1 className="svc-hero-title">Microsoft Fabric<br/>Consulting</h1>
          <p className="svc-hero-subtitle">UNIFIED ANALYTICS PLATFORM FOR THE MODERN ENTERPRISE.</p>
          <p className="svc-hero-desc">End-to-end consulting for Microsoft Fabric — from architecture design to production deployment and ongoing optimization.</p>
          <div className="svc-hero-stats">
            <div className="svc-stat-item"><h3>50%</h3><p>Faster Data Processing</p></div>
            <div className="svc-stat-item"><h3>100%</h3><p>Cloud-Native</p></div>
            <div className="svc-stat-item"><h3>5x</h3><p>ROI Improvement</p></div>
          </div>
          <div className="svc-hero-cta">
            <button className="svc-btn-primary" onClick={onContactClick}>Book a Call</button>
            <button className="svc-btn-secondary"><span>▶</span> Learn More</button>
          </div>
        </div>
        <div className="svc-hero-visual">
          <div className="svc-glowing-ring">☁️</div>
        </div>
      </section>

      <section className="svc-features-section">
        <h2 className="svc-section-title">Fabric Consulting Services</h2>
        <div className="svc-features-grid">
          {features.map((f, i) => (
            <div key={i} className="svc-feature-card">
              <div className="feature-icon">{f.icon}</div>
              <h3 className="feature-title">{f.title}</h3>
              <p className="feature-desc">{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="svc-cta-section">
        <div className="svc-cta-content">
          <h2>Ready to modernize your data stack?</h2>
          <p>Book a call and we'll assess your Fabric readiness and create a migration roadmap.</p>
          <button className="svc-btn-cta" onClick={onContactClick}>Book a Call</button>
        </div>
      </section>
    </div>
  );
};

export default MsFabricPage;
